export const IMAGE_EDITOR_TOOLBAR_HEIGHT = 60
